import { ChannelType } from 'common/core/constants/ChannelType'

export const FOLLOW_REPLY_CHANNEL = ChannelType.INSTAGRAM
